// extracted by mini-css-extract-plugin
export default {"base":"HorizontalMultiBarChartDisplay_base__QGr0J","select":"HorizontalMultiBarChartDisplay_select__ZwQA7"};